import React from 'react'
import PropTypes from 'prop-types'
import { ItemPreview } from './ItemPreview'
import isEmpty from 'lodash/isEmpty'
import { triggerClickOnEnter, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

const NavigationArrow = ({
  side,
  onClick,
  onHover,
  item
}) => {

  const handleOnClick = (e) => {
    e.currentTarget.blur()
    onClick(e)
  }

  return (
    <div
      className={`navigation-arrow-container ${side} `}
      onClick={handleOnClick}
      onKeyDown={triggerClickOnEnter}
      tabIndex={TAB_INDEXES.NavigationArrow}
      role="button"
    >
      <span className={`nav-arrow ${side}`} onMouseEnter={onHover} />
      <span className={`nav-arrow-icon icon-chevron-${side}`} />
      { !isEmpty(item) &&
        <ItemPreview className={`${side}-item-preview`} item={item} /> }
    </div>
  )
}

NavigationArrow.propTypes = {
  side: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onHover: PropTypes.func,
  item: PropTypes.object
}

export default NavigationArrow